import axios from '@_system/axios/axios.js'
export default {
	path: '/collectionsupplier',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	copyBycode(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/copyBycode', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	checkrelationorder(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/checkrelationorder', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	purchaseQuery(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/purchaseQuery', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	queryPurchaseStockBill(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/queryPurchaseStockBill', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getflowinfo(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getflowinfo', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	
	
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/collectionsupplier.collectionsupplier', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},

	// saleorderimport(id, data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderimport/' + id, data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
	// saleorderexport(data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderexport', data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
}
